jQuery(document).ready(function($)
{
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										STICKY ADD TO CART (mobiel)
	/////////////////////////////////////////////////////////////////////////////////////////////////
	// De markup komt server-side van Clients-Parent/library/class-nw-sticky-add-to-cart.php en
	// staat alleen op productpagina's waar de balk aan staat (start met hidden + inert).
	//
	// De balk is nooit een eigen formulier: een klik stuurt altijd het ORIGINELE WooCommerce-
	// formulier in, zodat WooCommerce zelf bepaalt wat er gebeurt (pagina herladen + melding,
	// of AJAX via een plugin) en alle meetsystemen (GA4, pixels) blijven werken.
	//
	// Zichtbaar zodra ALLE voorwaarden kloppen:
	// - mobiel formaat (smaller dan medium-breekpunt, niet te laag scherm zoals liggend)
	// - CookieYes-keuze is gemaakt (of er is geen CookieYes actief)
	// - de bezoeker is VOORBIJ de originele "In winkelmand"-knop gescrold (knop boven het scherm uit
	//   beeld). Ligt de knop nog ónder het scherm, dan bewust geen balk: de bezoeker komt de knop
	//   vanzelf tegen, en anders verschijnt de balk ook weer bij terug omhoog scrollen.
	// - er is geen tekstveld/keuzelijst actief (anders zit het mobiele toetsenbord/picker in de weg)

	var $nw_sticky_atc = $('#nw-sticky-atc');

	if ($nw_sticky_atc.length === 0)
	{
		return;
	}

	// Het formulier van HET product van deze pagina: plugins (upsells, "vaak samen gekocht") kunnen
	// eigen form.cart-elementen toevoegen, soms boven het hoofdproduct. WooCommerce zet het
	// hoofdproduct in een wrapper met id="product-{ID}"; alleen als die ontbreekt terugvallen op het
	// eerste form.cart.
	var $nw_sticky_atc_form = $('#product-' + parseInt($nw_sticky_atc.data('product-id'), 10) + ' form.cart').first();

	if ($nw_sticky_atc_form.length === 0)
	{
		$nw_sticky_atc_form = $('form.cart').first();
	}

	var $nw_sticky_atc_original = $nw_sticky_atc_form.find('.single_add_to_cart_button').first();

	// Zonder origineel formulier/knop is er niets om naar door te sturen
	if ($nw_sticky_atc_form.length === 0 || $nw_sticky_atc_original.length === 0 || !('IntersectionObserver' in window))
	{
		return;
	}

	var $nw_sticky_atc_button     = $nw_sticky_atc.find('.nw-sticky-atc__button');
	var $nw_sticky_atc_price      = $nw_sticky_atc.find('.nw-sticky-atc__price');
	var $nw_sticky_atc_qty_wrap   = $nw_sticky_atc.find('.nw-sticky-atc__quantity');
	var $nw_sticky_atc_qty_value  = $nw_sticky_atc.find('.nw-sticky-atc__qty-value');
	var $nw_sticky_atc_qty_minus  = $nw_sticky_atc.find('.nw-sticky-atc__qty-minus');
	var $nw_sticky_atc_qty_plus   = $nw_sticky_atc.find('.nw-sticky-atc__qty-plus');
	var $nw_sticky_atc_qty_input  = $nw_sticky_atc_form.find('.quantity input.qty[name="quantity"]').first();

	var nw_sticky_atc_default_price = $nw_sticky_atc_price.html();
	var nw_sticky_atc_default_text  = $nw_sticky_atc_button.text();
	var nw_sticky_atc_i18n          = {
		unavailable:    $nw_sticky_atc.data('i18n-unavailable'),
		select_options: $nw_sticky_atc.data('i18n-select-options')
	};

	// 639.98px i.p.v. 639px: voorkomt een gat bij fractionele viewport-breedtes (zoom/DPR)
	var nw_sticky_atc_query          = window.matchMedia('(max-width: 639.98px) and (min-height: 500px)');
	var nw_sticky_atc_reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)');

	// Ruimte (px) bovenin die door de vaste header bedekt kan zijn, zie nw_sticky_atc_init()
	var NW_STICKY_ATC_HEADER_MARGIN = 100;

	var nw_sticky_atc_state = {
		enabled:         false,
		original_passed: false,
		input_focused:   false,
		visible:         false
	};

	nw_sticky_atc_init();

	/**
	 * Koppelt alle observers en event handlers.
	 */
	function nw_sticky_atc_init()
	{
		// Bovenste 100px van het scherm telt niet als "in beeld": daar zit de vaste header, waar de
		// originele knop achter kan verdwijnen terwijl hij technisch nog in de viewport staat.
		// Vaste waarde i.p.v. meten, omdat de header tijdens scrollen van hoogte verandert (krimpend logo).
		var original_observer = new IntersectionObserver(nw_sticky_atc_on_original_intersect, {
			rootMargin: '-' + NW_STICKY_ATC_HEADER_MARGIN + 'px 0px 0px 0px'
		});
		original_observer.observe($nw_sticky_atc_original[0]);

		// Volgt de status van de originele knop (WooCommerce wisselt de classes bij variaties)
		var button_observer = new MutationObserver(nw_sticky_atc_sync_button_state);
		button_observer.observe($nw_sticky_atc_original[0], { attributes: true, attributeFilter: ['class', 'disabled'] });

		if ('ResizeObserver' in window)
		{
			var resize_observer = new ResizeObserver(nw_sticky_atc_set_offset);
			resize_observer.observe($nw_sticky_atc[0]);
		}

		nw_sticky_atc_query.addEventListener('change', nw_sticky_atc_on_query_change);
		document.addEventListener('focusin', nw_sticky_atc_on_focus_change);
		document.addEventListener('focusout', nw_sticky_atc_on_focus_out);

		// CookieYes vuurt dit event af op document zodra de bezoeker een keuze maakt
		document.addEventListener('cookieyes_consent_update', nw_sticky_atc_update);

		$nw_sticky_atc_button.on('click', nw_sticky_atc_on_button_click);
		$nw_sticky_atc_qty_minus.on('click', nw_sticky_atc_on_qty_minus);
		$nw_sticky_atc_qty_plus.on('click', nw_sticky_atc_on_qty_plus);
		$nw_sticky_atc_qty_input.on('input change', nw_sticky_atc_sync_quantity);

		// WooCommerce variatie-events (add-to-cart-variation.js). Onze handlers draaien ná die
		// van WooCommerce, dus aantal-veld (min/max/verborgen) is dan al bijgewerkt.
		$nw_sticky_atc_form.on('found_variation', nw_sticky_atc_on_found_variation);
		$nw_sticky_atc_form.on('reset_data', nw_sticky_atc_on_reset_data);
		$nw_sticky_atc_form.on('change', '.variations select', nw_sticky_atc_on_variation_select_change);

		nw_sticky_atc_sync_button_state();
		nw_sticky_atc_sync_quantity();
		nw_sticky_atc_on_query_change(nw_sticky_atc_query);
	}

	/**
	 * Bepaalt aan de hand van de huidige state of de balk zichtbaar moet zijn en past dat toe.
	 */
	function nw_sticky_atc_update()
	{
		var should_show = nw_sticky_atc_state.enabled
			&& nw_sticky_atc_state.original_passed
			&& !nw_sticky_atc_state.input_focused
			&& nw_sticky_atc_has_cookie_choice();

		if (should_show === nw_sticky_atc_state.visible)
		{
			return;
		}

		nw_sticky_atc_state.visible = should_show;

		$nw_sticky_atc.toggleClass('is-visible', should_show);
		// inert: niet focusbaar/klikbaar en onzichtbaar voor schermlezers zolang de balk buiten beeld is
		$nw_sticky_atc.prop('inert', !should_show);
		$('body').toggleClass('nw-sticky-atc-visible', should_show);

		nw_sticky_atc_set_offset();
	}

	/**
	 * Of de bezoeker al een keuze heeft gemaakt in de CookieYes-banner.
	 *
	 * Wordt bij elke update opnieuw bepaald (niet eenmalig bij init), omdat het CookieYes-script
	 * later geladen kan worden dan dit script.
	 *
	 * @return {boolean} True als er een keuze is gemaakt of als CookieYes niet actief is.
	 */
	function nw_sticky_atc_has_cookie_choice()
	{
		if (typeof window.getCkyConsent !== 'function')
		{
			return true;
		}

		return window.getCkyConsent().isUserActionCompleted === true;
	}

	/**
	 * Zet de hoogte van de zichtbare balk in --nw-sticky-atc-offset op :root.
	 *
	 * Gebruikt door de footer-padding (SCSS) en de WhatsApp-knop (nowweb-whatsapp-knop plugin)
	 * om ruimte te maken voor de balk.
	 */
	function nw_sticky_atc_set_offset()
	{
		var offset = nw_sticky_atc_state.visible ? $nw_sticky_atc.outerHeight() : 0;

		document.documentElement.style.setProperty('--nw-sticky-atc-offset', offset + 'px');
	}

	/**
	 * Activeert of deactiveert de balk bij het passeren van het mobiele breekpunt / draaien van het scherm.
	 *
	 * @param {MediaQueryList|MediaQueryListEvent} query
	 */
	function nw_sticky_atc_on_query_change(query)
	{
		nw_sticky_atc_state.enabled = query.matches;

		// Buiten mobiel formaat volledig verborgen, zodat de balk op desktop nooit ruimte of focus inneemt
		$nw_sticky_atc.prop('hidden', !query.matches);

		nw_sticky_atc_update();
	}

	/**
	 * Bepaalt of de bezoeker voorbij de originele knop is gescrold.
	 *
	 * "Buiten beeld" alleen is niet genoeg: dat geldt ook als de knop nog ónder het scherm ligt.
	 * Alleen als de knop niet in beeld is én zijn bovenkant boven het zichtbare gebied ligt (onder
	 * de header-marge), is hij gepasseerd. De IntersectionObserver vuurt ook direct bij het
	 * observeren, dus een pagina die al gescrold geladen wordt (terug-knop, anker) wordt meteen
	 * goed afgehandeld.
	 *
	 * @param {IntersectionObserverEntry[]} entries
	 */
	function nw_sticky_atc_on_original_intersect(entries)
	{
		var entry    = entries[entries.length - 1];
		var rect     = entry.boundingClientRect;
		// rootBounds is de viewport mínus de rootMargin; alleen null in cross-origin iframes
		var root_top = entry.rootBounds ? entry.rootBounds.top : NW_STICKY_ATC_HEADER_MARGIN;

		// Een verborgen knop (display:none, bijv. door een offerte-/prijs-verbergen-plugin) heeft geen
		// afmetingen en top 0 - dat zou anders als "gepasseerd" gelden en de balk direct tonen
		if (rect.width === 0 && rect.height === 0)
		{
			nw_sticky_atc_state.original_passed = false;
			nw_sticky_atc_update();
			return;
		}

		nw_sticky_atc_state.original_passed = !entry.isIntersecting && rect.top < root_top;

		nw_sticky_atc_update();
	}

	/**
	 * Of een element bij focus het mobiele toetsenbord of een keuzelijst-picker opent.
	 *
	 * @param {Element|null} element
	 *
	 * @return {boolean}
	 */
	function nw_sticky_atc_opens_keyboard(element)
	{
		if (!element || !element.tagName)
		{
			return false;
		}

		var tag = element.tagName.toLowerCase();

		if (tag === 'textarea' || tag === 'select' || element.isContentEditable)
		{
			return true;
		}

		if (tag !== 'input')
		{
			return false;
		}

		var type = (element.getAttribute('type') || 'text').toLowerCase();

		return ['checkbox', 'radio', 'button', 'submit', 'reset', 'image', 'range', 'color', 'file', 'hidden'].indexOf(type) === -1;
	}

	/**
	 * Verbergt de balk zolang een veld met toetsenbord/picker focus heeft.
	 */
	function nw_sticky_atc_on_focus_change()
	{
		nw_sticky_atc_state.input_focused = nw_sticky_atc_opens_keyboard(document.activeElement);

		nw_sticky_atc_update();
	}

	/**
	 * Bij focusout staat document.activeElement nog even op body voordat het volgende element
	 * focus krijgt; kort wachten voorkomt dat de balk tussen twee velden door heel even verschijnt.
	 */
	function nw_sticky_atc_on_focus_out()
	{
		window.setTimeout(nw_sticky_atc_on_focus_change, 100);
	}

	/**
	 * Klik op de knop in de balk: doorsturen naar het originele formulier.
	 *
	 * @param {jQuery.Event} event
	 */
	function nw_sticky_atc_on_button_click(event)
	{
		event.preventDefault();

		if ($nw_sticky_atc_original.hasClass('wc-variation-is-unavailable'))
		{
			return;
		}

		// Nog niet alle variaties gekozen (of een andere plugin houdt de knop uitgeschakeld):
		// terug naar het formulier i.p.v. variaties in de balk te proppen
		if ($nw_sticky_atc_original.hasClass('wc-variation-selection-needed') || $nw_sticky_atc_original.is(':disabled'))
		{
			nw_sticky_atc_push_datalayer('select_options');
			nw_sticky_atc_guide_to_form();
			return;
		}

		// Vóór de klik pushen: een klik op het origineel kan de pagina direct laten herladen
		nw_sticky_atc_push_datalayer('add_to_cart');

		// Native click() i.p.v. form.submit(): submit() slaat klik-/submit-listeners over (tracking,
		// AJAX add-to-cart plugins) én verliest name="add-to-cart" van de knop bij simpele producten.
		// Een native click laat ook de browser-validatie van verplichte extra velden gewoon werken.
		$nw_sticky_atc_original[0].click();
	}

	/**
	 * Zet een klik op de balk in de dataLayer, zodat in GTM/GA4 te meten is hoe vaak de balk
	 * gebruikt wordt t.o.v. de originele knop.
	 *
	 * Bewust een eigen event naast de bestaande add_to_cart-metingen: die blijven gewoon via de
	 * originele knop/WooCommerce lopen, dit event telt dus niet dubbel als conversie. Bevat geen
	 * persoonsgegevens. Bij 'add_to_cart' is niet gegarandeerd dat het product daadwerkelijk is
	 * toegevoegd (bijv. browser-validatie van een verplicht veld houdt het formulier tegen).
	 *
	 * @param {string} action 'add_to_cart' (origineel formulier wordt verstuurd) of
	 *                        'select_options' (bezoeker wordt naar de variatie-keuze gestuurd).
	 */
	function nw_sticky_atc_push_datalayer(action)
	{
		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			event:                  'nw_sticky_atc_click',
			nw_sticky_atc_action:   action,
			nw_sticky_atc_product:  $nw_sticky_atc.data('product-id'),
			nw_sticky_atc_type:     $nw_sticky_atc.data('product-type'),
			nw_sticky_atc_quantity: $nw_sticky_atc_qty_input.length > 0 ? parseFloat($nw_sticky_atc_qty_input.val()) || 1 : 1
		});
	}

	/**
	 * Scrolt naar de eerste nog niet gekozen variatie en toont een melding waarom.
	 */
	function nw_sticky_atc_guide_to_form()
	{
		var $first_empty = $nw_sticky_atc_form.find('.variations select').filter(nw_sticky_atc_select_is_empty).first();
		var $target      = $first_empty.length > 0 ? $first_empty : $nw_sticky_atc_form;

		nw_sticky_atc_show_form_notice();

		$target[0].scrollIntoView({
			behavior: nw_sticky_atc_reduced_motion.matches ? 'auto' : 'smooth',
			block:    'center'
		});

		if ($first_empty.length > 0)
		{
			$first_empty.closest('tr').addClass('nw-sticky-atc-attention');
			// Focus voor toetsenbord- en schermlezergebruikers; scrollen doet scrollIntoView al
			$first_empty[0].focus({ preventScroll: true });
		}
	}

	/**
	 * jQuery .filter()-callback: of een variatie-select nog geen waarde heeft.
	 *
	 * @return {boolean}
	 */
	function nw_sticky_atc_select_is_empty()
	{
		return !$(this).val();
	}

	/**
	 * Toont (eenmalig) de melding "Kies eerst een optie" boven de variaties.
	 */
	function nw_sticky_atc_show_form_notice()
	{
		if ($nw_sticky_atc_form.find('.nw-sticky-atc-notice').length > 0)
		{
			return;
		}

		// .text() i.p.v. .html(): de melding komt uit een data-attribuut en mag geen HTML bevatten
		var $notice = $('<p class="nw-sticky-atc-notice" role="alert"></p>').text(nw_sticky_atc_i18n.select_options);
		var $table  = $nw_sticky_atc_form.find('.variations').first();

		if ($table.length > 0)
		{
			$table.before($notice);
		}
		else
		{
			$nw_sticky_atc_form.prepend($notice);
		}
	}

	/**
	 * Haalt melding en markeringen weg zodra alle variaties gekozen zijn.
	 */
	function nw_sticky_atc_clear_form_notice()
	{
		$nw_sticky_atc_form.find('.nw-sticky-atc-notice').remove();
		$nw_sticky_atc_form.find('.nw-sticky-atc-attention').removeClass('nw-sticky-atc-attention');
	}

	/**
	 * Haalt de markering weg van een variatie-rij zodra daar iets gekozen is.
	 */
	function nw_sticky_atc_on_variation_select_change()
	{
		if ($(this).val())
		{
			$(this).closest('tr').removeClass('nw-sticky-atc-attention');
		}
	}

	/**
	 * Neemt de status van de originele knop over (WooCommerce wisselt die bij variaties).
	 */
	function nw_sticky_atc_sync_button_state()
	{
		var unavailable = $nw_sticky_atc_original.hasClass('wc-variation-is-unavailable');

		$nw_sticky_atc_button
			.prop('disabled', unavailable)
			.text(unavailable ? nw_sticky_atc_i18n.unavailable : nw_sticky_atc_default_text);

		if (!$nw_sticky_atc_original.hasClass('wc-variation-selection-needed'))
		{
			nw_sticky_atc_clear_form_notice();
		}
	}

	/**
	 * @param {jQuery.Event} event
	 * @param {Object}       variation WooCommerce variatie-data
	 */
	function nw_sticky_atc_on_found_variation(event, variation)
	{
		// price_html is leeg als alle variaties dezelfde prijs hebben: dan de basisprijs houden.
		// price_html is door WooCommerce server-side gegenereerde HTML (WooCommerce plaatst hem zelf ook via .html()).
		if (variation && variation.price_html)
		{
			$nw_sticky_atc_price.html(variation.price_html);
		}
		else
		{
			$nw_sticky_atc_price.html(nw_sticky_atc_default_price);
		}

		nw_sticky_atc_sync_quantity();
	}

	/**
	 * Variatie-keuze gewist of combinatie bestaat niet: terug naar de basisprijs.
	 */
	function nw_sticky_atc_on_reset_data()
	{
		$nw_sticky_atc_price.html(nw_sticky_atc_default_price);

		nw_sticky_atc_sync_quantity();
	}

	/**
	 * Leest min/max/step van het originele aantal-veld.
	 *
	 * @return {{min: number, max: number, step: number}} max is Infinity als er geen maximum is.
	 */
	function nw_sticky_atc_get_qty_limits()
	{
		var min  = parseFloat($nw_sticky_atc_qty_input.attr('min'));
		var max  = parseFloat($nw_sticky_atc_qty_input.attr('max'));
		var step = parseFloat($nw_sticky_atc_qty_input.attr('step'));

		return {
			min:  isNaN(min) ? 1 : min,
			max:  (isNaN(max) || max <= 0) ? Infinity : max,
			step: (isNaN(step) || step <= 0) ? 1 : step
		};
	}

	/**
	 * Aantal decimalen van de stapgrootte, om afrondingsfouten (0.1 + 0.2) weg te poetsen.
	 *
	 * @param {number} step
	 *
	 * @return {number}
	 */
	function nw_sticky_atc_step_decimals(step)
	{
		var parts = String(step).split('.');

		return parts.length > 1 ? parts[1].length : 0;
	}

	/**
	 * Zet een nieuw aantal in het ORIGINELE veld (bron van waarheid) en werkt de balk bij.
	 *
	 * @param {number} direction -1 of 1
	 */
	function nw_sticky_atc_change_quantity(direction)
	{
		var limits  = nw_sticky_atc_get_qty_limits();
		var current = parseFloat($nw_sticky_atc_qty_input.val());

		if (isNaN(current))
		{
			current = limits.min;
		}

		var next = current + (direction * limits.step);

		next = Math.min(Math.max(next, limits.min), limits.max);
		next = parseFloat(next.toFixed(nw_sticky_atc_step_decimals(limits.step)));

		// change-event zodat WooCommerce en plugins (bijv. prijs x aantal) het ook oppikken
		$nw_sticky_atc_qty_input.val(next).trigger('change');
	}

	function nw_sticky_atc_on_qty_minus()
	{
		nw_sticky_atc_change_quantity(-1);
	}

	function nw_sticky_atc_on_qty_plus()
	{
		nw_sticky_atc_change_quantity(1);
	}

	/**
	 * Neemt waarde, grenzen en zichtbaarheid van het originele aantal-veld over in de balk.
	 */
	function nw_sticky_atc_sync_quantity()
	{
		if ($nw_sticky_atc_qty_wrap.length === 0)
		{
			return;
		}

		// Geen (zichtbaar) aantal-veld: los verkocht product/variatie, of min = max
		var has_quantity = $nw_sticky_atc_qty_input.length > 0
			&& $nw_sticky_atc_qty_input.attr('type') !== 'hidden'
			&& $nw_sticky_atc_qty_input.closest('.quantity').css('display') !== 'none';

		$nw_sticky_atc_qty_wrap.prop('hidden', !has_quantity);

		if (!has_quantity)
		{
			return;
		}

		var limits = nw_sticky_atc_get_qty_limits();
		var value  = parseFloat($nw_sticky_atc_qty_input.val());

		if (isNaN(value))
		{
			value = limits.min;
		}

		$nw_sticky_atc_qty_value.text(value);
		$nw_sticky_atc_qty_minus.prop('disabled', value <= limits.min);
		$nw_sticky_atc_qty_plus.prop('disabled', value >= limits.max);

		// Hoogte kan veranderen als de aantal-knoppen verschijnen/verdwijnen
		nw_sticky_atc_set_offset();
	}
});
